const REGOP = {
    C002TiposDependencias: 'REGOP/Catalogos/GetTiposDependencias',
    C003TiposEnvio: 'REGOP/Catalogos/GetTiposEnvio',
  };
    
  export default REGOP;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/REGOP/catalogos/catalogos.js
// module id = null
// module chunks = 